module.exports = __webpack_public_path__ + "img/ic_teacher_gaokao.7bb764dd.png";